/* assets/map.js  ──  Único contenido */

/* assets/map.js — versión con centrado al clicar en la tienda */

window.initGoogleMap = () => {
  if (customElements.get("google-map")) return; // evita doble registro

  class GoogleMap extends HTMLElement {
    connectedCallback() {
      // --- 1. Crea el mapa ---------------------------------------------------
      this.mapEl = this.querySelector(".google-map--map");
      this.bounds = new google.maps.LatLngBounds();

      this.map = new google.maps.Map(this.mapEl, {
        center: { lat: 40, lng: -4 },
        zoom: 5,
        mapTypeId: this.dataset.mapType || "roadmap",
        gestureHandling: "cooperative",
        fullscreenControl: false,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      });

      // --- 2. Añade pines desde los inputs -----------------------------------
      const markers = []; // guardamos referencias para uso futuro

      this.querySelectorAll(".thb-location").forEach((input) => {
        const opt = JSON.parse(input.dataset.option),
          pos = { lat: opt.latitude, lng: opt.longitude };

        const marker = new google.maps.Marker({
          position: pos,
          map: this.map,
          icon: {
            url: opt.marker_image,
            size: new google.maps.Size(opt.marker_size[0], opt.marker_size[1]),
            scaledSize: new google.maps.Size(
              opt.marker_size[0],
              opt.marker_size[1]
            ),
          },
        });

        markers.push({ marker, lat: pos.lat, lng: pos.lng });
        this.bounds.extend(pos);
      });

      if (!this.bounds.isEmpty()) this.map.fitBounds(this.bounds);

      // --- 3. Centrar mapa cuando se hace clic en una tienda -----------------
      this.querySelectorAll(".store-trigger").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault(); // cancelamos toggle nativo
          const currentDetails = btn.closest("details");

          /* Cierra cualquier otra tienda que esté abierta */
          this.querySelectorAll(
            ".google-map--information details[open]"
          ).forEach((d) => {
            if (d !== currentDetails) d.removeAttribute("open");
          });

          /* Alterna la tienda actual */
          if (currentDetails.hasAttribute("open")) {
            currentDetails.removeAttribute("open"); // ya estaba abierta → ciérrala
          } else {
            currentDetails.setAttribute("open", ""); // ábrela
          }

          /* Centra el mapa en la tienda clicada */
          const lat = parseFloat(btn.dataset.lat);
          const lng = parseFloat(btn.dataset.lng);
          if (!isNaN(lat) && !isNaN(lng)) {
            this.map.panTo({ lat, lng });
            this.map.setZoom(16);
          }
        });
      });
    }
  }

  customElements.define("google-map", GoogleMap);
};

const markers = []; // guarda las instancias

// --- dentro de tu loop que crea cada marker ---
const marker = new google.maps.Marker({
  /* … */
});
markers.push(marker);
// ----------------------------------------------

// después de crear todos:
this.map.addListener("zoom_changed", () => {
  const z = this.map.getZoom();
  markers.forEach((m) => {
    const iconSize = z < 8 ? [20, 26] : z < 12 ? [28, 36] : [40, 54];
    const u = m.getIcon().url; // misma URL
    m.setIcon({
      url: u,
      size: new google.maps.Size(...iconSize),
      scaledSize: new google.maps.Size(...iconSize),
    });
  });
});
